import { setContext } from '@apollo/client/link/context';

export const authLink = setContext(() => {
  const headers = {
    authorization: window.localStorage.getItem('onyo-token'),
  };
  return { headers };
});
